<script>
export default {
  props: {
    options: {
      type: Array,
      default: null,
    },

    label: {
      type: String,
      default: '',
    },

    value: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    allSelected() {
      return this.value.length >= this.options.length
    },
  },

  methods: {
    toggleAll(checked) {
      this.$emit(
        'input',
        this.allSelected ? [] : this.options.map((a) => a.value).slice()
      )
    },
  },
}
</script>

<template>
  <b-form-group>
    <template #label>
      <b-form-checkbox
        aria-describedby="options"
        aria-controls="options"
        :checked="allSelected"
        size="lg"
        @input="toggleAll"
      >
        {{ label }}
      </b-form-checkbox>
    </template>
    <b-form-checkbox-group
      :checked="value"
      name="options"
      class="ml-4"
      :options="options"
      size="lg"
      @input="$emit('input', $event)"
    >
    </b-form-checkbox-group>
  </b-form-group>
</template>

<style lang="scss" module>
@import '@variables';
</style>
